import {Component, Input, OnInit, ViewEncapsulation, Injector, OnChanges, SimpleChanges, Inject} from '@angular/core';
import {GtmService} from "../../services/gtm.service";
import {AdType} from "../ads-banners/ads-banners.component";
import {AbstractComponent} from "../abstract.component";
import { Module } from 'projects/common/model/ModuleModel';
import { Device } from '../../model/Device';
import { DOCUMENT } from '@angular/common';

interface Group {
  description: string;
  interlinks: Interlink[];
}

interface Interlink {
  text: string;
  link: string;
}

@Component({
  selector: 'grouped-interlink',
  template: `
    <div class="eva-3-card grouped-interlink -eva-3-shadow-line -eva-3-p-md">
      <text *ngIf="module.pretitle || module.title || module.subtitle" [data]="module"></text>

      <div class="interlink-with-ad">
        <div class="group group-size-{{groupSize}}">
          <div class="group-item" *ngFor="let group of module.data; let i = index">
            <div class="-eva-3-bold -eva-3-mb-xlg">{{group.description}}</div>
            <div class="interlinks-wrapper">
              <ng-container *ngFor="let interlink of group.interlinks; let i = index">
                <a *ngIf="interlink.link && interlink.text" class="interlink eva-3-link" [href]="interlink.link"
                  (click)="trackGtm(interlink.text, i)">{{interlink.text}}</a>
              </ng-container>
            </div>
          </div>
        </div>
        <ads-banners *ngIf="googleAdsEnabled" class="ad" [bannerType]="bannerType" [moduleId]="MODULE_ID"></ads-banners>
      </div>
    </div>
  `,
  styleUrls: ['./grouped-interlinks.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GroupedInterlinksComponent extends AbstractComponent implements OnInit {
  public MODULE_ID: string = "GroupedInterlinksModule";
  @Input() override module: Module<Group[]>;
  @Input() device: Device;
  bannerType = AdType.BOTTOM_SQUARE;
  googleAdsEnabled: boolean = false;
  groupSize: number;

  constructor(private gtmService: GtmService, injector: Injector, @Inject(DOCUMENT) private document: Document) {
    super(injector);
  }

  ngOnInit() {
    this.googleAdsEnabled =  this.landingModelService.getLandingModel().googleAds.enabled;
    const showModule = this.module?.data?.some(group => group.interlinks?.some(item => this.isNotEmpty(item)));
    if (!showModule && this.module.unique_id) {
      this.document.getElementById(this.module.unique_id)?.classList?.add("-hidden");
    }
    this.groupSize = this.module.data.length > 2 && this.device.type === 'MOBILE' ? 2 : this.module.data.length;
  }

  trackGtm(interlinkText, i) {
    this.gtmService.trackEventIfApplicable("user-action", "grouped-interlink-" + i, "Click", interlinkText)
  }

  getModuleId(): string {
    return this.MODULE_ID;
  }

  isNotEmpty = (interlink: Interlink) : boolean => {
    return Boolean(interlink.link?.trim() && interlink.text?.trim());
  }
}
